import { render, staticRenderFns } from "./AppSidebar.vue?vue&type=template&id=34c6e6c4&scoped=true&"
import script from "./AppSidebar.vue?vue&type=script&lang=js&"
export * from "./AppSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AppSidebar.vue?vue&type=style&index=0&id=34c6e6c4&scoped=true&lang=css&"
import style1 from "./AppSidebar.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c6e6c4",
  null
  
)

export default component.exports